module.exports = __webpack_public_path__ + "img/2.e881bcd1.jpg";